import React, { memo } from 'react';
import styled from 'styled-components';
import CheckmarkIcon from 'ui/icons/checkmark.svg?react';
import { animated, useSpring } from 'react-spring';

const CheckboxIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: relative;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.grey[900]};
  height: ${({ theme }) => theme.space.xl};
  width: ${({ theme }) => theme.space.xl};
  padding: ${({ theme }) => theme.space.xxs};
  border-radius: 24px;
  margin: 0;
`;

const CheckboxIcon = memo(() => {
  const animationConfig = {
    mass: 1,
    tension: 500,
    friction: 30
  };

  const slideInOutProps = useSpring({
    display: 'flex',
    config: animationConfig
  });

  return (
    <CheckboxIconWrapper>
      <animated.div style={slideInOutProps}>
        <CheckmarkIcon color="white" width="12" height="9" />
      </animated.div>
    </CheckboxIconWrapper>
  );
});

export default CheckboxIcon;
